import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { VStack } from '~/components/elements/VStack'

import styles from './ColumnDisplayToggleForm.css'
import {
  ColumnDisplayToggleFormItem,
  type ColumnDisplayToggleFormItemProps,
} from './ColumnDisplayToggleFormItem'

export type ColumnDisplayToggleFormProps<ColumnKey extends string> = {
  items: ColumnDisplayToggleFormItemProps<ColumnKey>['item'][]
  onChange?: (value: boolean, columnKeys: ColumnKey[]) => void
}

export const ColumnDisplayToggleForm = <ColumnKey extends string>({
  items,
  onChange,
}: ColumnDisplayToggleFormProps<ColumnKey>) => {
  const { t } = useTranslation()
  const isAllChecked = React.useMemo<CheckboxProps['checked']>(
    () =>
      items.every((item) => item.isVisible)
        ? true
        : items.every((item) => !item.isVisible)
          ? false
          : null,
    [items],
  )

  const handleAllChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      const columnKeys = items.map((item) => item.columnKey)

      onChange?.(event.value, columnKeys)
    },
    [items, onChange],
  )

  return (
    <VStack spacing={2}>
      <Checkbox
        checked={isAllChecked}
        label={t('sellect_all')}
        onChange={handleAllChange}
      />

      <VStack className={styles.items} spacing={2}>
        {items.map((item) => (
          <ColumnDisplayToggleFormItem
            key={item.label}
            item={item}
            onChange={onChange}
          />
        ))}
      </VStack>
    </VStack>
  )
}
